var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacadeRecommended(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 203 104",
    style: {
      enableBackground: "new 0 0 203 104"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.facade-recommended-mob-st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.facade-recommended-mob-st1{fill:#FFFFFF;}\n\t.facade-recommended-mob-st2{opacity:0.2;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.facade-recommended-mob-st3{opacity:0.2;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-mob-st0",
    d: "M109.3,29.6l-1.6,20.9H86.3l-1.6-20.9l4.2-3.6c0.2,3.5,2.3,10.4,8.3,10.4c6,0,8.1-6.7,8.2-10.4L109.3,29.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-mob-st1",
    d: "M94.9,53.4h-2.1c0.3,13.7-5.7,23.6-11.1,32.4c-3.4,5.3-6.3,10.2-7.4,15.2c1.1,0.4,3,0.9,5.9,1.5 c0.6-5.3,3.3-10.6,6.1-16.2C91,77.1,96.2,66.8,94.9,53.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-mob-st1",
    d: "M101.1,53.4H99c2.3,13.7-2.1,24.6-6,34.4c-2.3,5.6-4.3,10.8-4.7,15.6c1.8,0.1,3.8,0.2,6,0.3 c0.3-4.6,1.8-9.6,3.5-15C100.9,78.4,104.5,66.9,101.1,53.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-mob-st1",
    d: "M98,53.4h-2.1c1.3,13.6-4,24.1-8.6,33.3c-2.9,5.7-5.4,10.8-6,15.9c1.7,0.3,3.7,0.5,6,0.7 c0.4-5.1,2.5-10.3,4.8-15.9C95.9,77.8,100.3,66.9,98,53.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-mob-st1",
    d: "M91.7,53.4h-2.1C89.1,65,84.1,73.5,78.8,81l-5.5,19.6c0,0,0,0,0.1,0.1c1.1-5.1,4.1-10.1,7.4-15.4 C86.1,76.6,92.1,66.8,91.7,53.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-mob-st1",
    d: "M116,102.2c3.9-0.8,5.5-1.6,5.5-1.6l-4.6-16.2c-0.1,2.9-0.3,5.6-0.5,8.3C116.3,96.1,116,99.3,116,102.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-mob-st1",
    d: "M86.6,53.4L79.7,78c4.5-6.7,8.5-14.5,8.9-24.6H86.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-mob-st1",
    d: "M110.5,91.4c-0.6,4.3-1.2,8.3-1.3,11.8c2.3-0.2,4.2-0.5,5.8-0.8c0-3,0.2-6.3,0.5-9.8 c0.2-3.6,0.5-7.4,0.5-11.5l-4.5-15.9C112.8,74.7,111.6,83.7,110.5,91.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-mob-st1",
    d: "M104.3,53.4h-2.1c3.3,13.7-0.3,25.3-3.4,35.5c-1.7,5.4-3.2,10.3-3.4,14.8c0.7,0,1.4,0,2.1,0 c1.4,0,2.7,0,3.9-0.1c0.2-4.2,1.2-8.8,2.3-13.7C106,79.1,108.7,67,104.3,53.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-mob-st1",
    d: "M107.4,53.4h-2.1c4.3,13.7,1.7,25.9-0.7,36.7c-1.1,4.9-2.1,9.4-2.2,13.5c2.2-0.1,4.1-0.2,5.9-0.4 c0.1-3.7,0.7-7.7,1.3-12C111.1,79.9,112.9,67.1,107.4,53.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-mob-st2",
    d: "M63.8,69.8l-8.7-9l-7.9,1.9L36.9,50.2l-3.6-5.5h-5.2l1.5,8.5l0.1,0.1l1.7,16.3h2.5c0-2-1.5-9.9,1.9-9.6 l8.9,9.8H63.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-mob-st1",
    d: "M65,70.3l-9.7-10.1l-7.9,1.9L37.3,49.9l-3.7-5.7h-6.1l1.6,9.2l0.1,0.1l1.8,17.2h3.5v-0.5c0-0.4-0.1-1-0.1-1.7 c-0.2-2.2-0.6-6.2,0.7-7.2c0.3-0.2,0.7-0.3,1.2-0.1l8.4,9.2H65z M34.3,60.5c-1.6,1.3-1.3,5.4-1,8.1c0,0.4,0.1,0.8,0.1,1.1h-1.5 L30.3,55l4.8,5.1C34.8,60.1,34.6,60.3,34.3,60.5z M33,45.2l3.5,5.3L47,63.3l7.9-1.9l7.7,7.9H44.9L38,61.7l0.1,0l-1.5-1.6L30.1,53 l-1.4-7.8H33z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "facade-recommended-mob-st1",
    points: "96.3,7.7 91.9,3.4 92.7,2.6 96.3,6.3 101.9,0.6 102.7,1.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "facade-recommended-mob-st1",
    points: "37.9,7.7 33.5,3.4 34.3,2.6 37.9,6.3 43.5,0.6 44.3,1.4  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-mob-st1",
    d: "M173.7,45.9h-8.4l0.8-3.8h-17.3l0.8,3.8h-8.4l-5.7,26.6h43.8L173.7,45.9z M164.9,43.1l-1.4,6.5h-12.1l-1.4-6.5 H164.9z M142,46.9h7.8l0.7,3.4l0.1,0.3h0h13.7h0l0.1-0.3l0.7-3.4h7.8l5.2,24.6h-41.4L142,46.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "facade-recommended-mob-st3",
    points: "173.3,46.4 164.8,46.4 165.5,42.6 149.4,42.6 150.1,46.4 141.6,46.4 136.1,72 178.7,72  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "facade-recommended-mob-st1",
    points: "157,7.7 152.6,3.4 153.4,2.6 157,6.3 162.6,0.6 163.4,1.4  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacadeRecommended);
export default __webpack_public_path__ + "static/media/facade-recommended.8ac5f1e5.svg";
export { ForwardRef as ReactComponent };